"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateBooleanFieldChoices(field) {
    if (field.choices) {
        return field.choices;
    }
    if (field.default === 'yes' || field.default === 'no') {
        return [
            { value: true, label: 'Yes' },
            { value: false, label: 'No' },
        ];
    }
    return [
        { value: true, label: 'True' },
        { value: false, label: 'False' },
    ];
}
exports.default = generateBooleanFieldChoices;
